/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetHouseStatsDesktopFicheringRequest,
  TGetHouseStatsDesktopFicheringModel,
  IMappers,
  TGetHouseStatsDesktopFicheringResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingHouseStatsDesktopFicheringResponse } from '../../entities/get_newbuilding_house_stats_desktop_fichering/GetNewbuildingHouseStatsDesktopFicheringResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetHouseStatsDesktopFicheringModel(
  parameters: TGetHouseStatsDesktopFicheringRequest,
): TGetHouseStatsDesktopFicheringModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-card',
    pathApi: '/v1/get-house-stats-desktop-fichering/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetHouseStatsDesktopFicheringOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetHouseStatsDesktopFicheringRequest;
}

export async function fetchGetHouseStatsDesktopFichering<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseStatsDesktopFicheringOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetHouseStatsDesktopFicheringResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetHouseStatsDesktopFicheringModel(parameters),
    config,
  )) as FetchResponse<TGetHouseStatsDesktopFicheringResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingHouseStatsDesktopFicheringResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetHouseStatsDesktopFicheringResponse>;
}
